import { Component } from 'react';
import { css } from '@emotion/react';

import Grid2CellUnevenSplit from '../atoms/Grid2CellUnevenSplit';
import Image from '../atoms/Image';
import MediaQuery from '../atoms/MediaQuery';
import TitleTextGroup from './TitleTextGroup';
import SectionTop from './SectionTop';

import * as InternalPropTypes from '../../../constants/internal-types';
import * as Breakpoints from '../../../constants/breakpoints';
import ScreenSize from '../../../constants/screenSize';
import { SizesType } from '../../../types/ts/imgixQuery';
import { TypeSEOWeightTypes } from '../../../constants/cms-constants';
import SEOWeights from '../../../constants/cms/control-options/seo-weights';
import { getLowerSEOWeight } from '../../../utils/SEOWeight';

const styles = css({
  '& .section': {
    [Breakpoints.Mobile.mq]: {
      marginBottom: '40px',
    },
  },

  '& .title-text-group': {
    [Breakpoints.TabletUp.mq]: {
      position: 'absolute',
      bottom: '0',
    },
  },
  '& .section-container': {
    [Breakpoints.TabletUp.mq]: {
      position: 'relative',
      height: '100%',
    },
  },
  '& .image': {
    display: 'flex',
    flexDirection: 'row-reverse',
    objectFit: 'cover',
    [Breakpoints.DesktopUp.mq]: {
      width: '100%',
      height: '589px',
      paddingLeft: '75px',
    },
    [Breakpoints.Tablet.mq]: {
      width: '100%',
      height: '462px',
    },
    [Breakpoints.Mobile.mq]: {
      width: '100%',
      height: '426px',
      marginBottom: '18px',
    },
  },
});

type ImageTextsProps = {
  bodyText?: InternalPropTypes.RichText;
  header?: InternalPropTypes.RichText;
  lightHeader?: InternalPropTypes.RichText;
  titleText?: InternalPropTypes.RichText;
  image?: InternalPropTypes.Image;
  seoWeight?: TypeSEOWeightTypes;
};

class ImageTexts extends Component<ImageTextsProps> {
  static defaultProps = {
    bodyText: null,
    header: null,
    lightHeader: null,
    titleText: null,
    image: null,
    seoWeight: SEOWeights.H2,
  };

  render() {
    const { header, lightHeader, titleText, bodyText, image, seoWeight } =
      this.props;

    const sizes: SizesType = {
      [ScreenSize.Mobile]: { h: '426' },
      [ScreenSize.Tablet]: { h: '462' },
      [ScreenSize.Desktop]: { h: '589' },
    };
    const lowerSEOWeight = getLowerSEOWeight(seoWeight);

    return (
      <div css={styles} className="image-texts">
        <MediaQuery visible={Breakpoints.Mobile}>
          <SectionTop
            lightHeaderText={lightHeader}
            headerText={header}
            seoWeight={seoWeight}
          />
          <Image image={image} sizes={sizes} />
          <TitleTextGroup
            bodyText={bodyText}
            titleText={titleText}
            seoWeight={lowerSEOWeight}
          />
        </MediaQuery>

        <MediaQuery visible={Breakpoints.TabletUp}>
          <Grid2CellUnevenSplit
            leftCellCount={4}
            rightCellCount={7}
            onRenderCell1={() => (
              <div className="section-container">
                <SectionTop
                  lightHeaderText={lightHeader}
                  headerText={header}
                  seoWeight={seoWeight}
                />
                <TitleTextGroup
                  bodyText={bodyText}
                  titleText={titleText}
                  seoWeight={lowerSEOWeight}
                />
              </div>
            )}
            onRenderCell2={() => <Image image={image} sizes={sizes} />}
            snapAtBreakpoint={Breakpoints.MobileDown}
          />
        </MediaQuery>
      </div>
    );
  }
}

export default ImageTexts;
